import { Component } from '@angular/core';
import { ModalService } from '@lsq-frontend/common-ui';
import { I18n } from '@ngx-translate/i18n-polyfill';
@Component({
    selector: 'agreement-complete-check-modal',
    styleUrls: ['./agreement-complete-check-modal.component.scss'],
    template: `
        <div class="agreement-complete-check-modal">
            <div class="bottom-margin" *ngIf="agreementCompleted">
                <p class="body">
                    {{ modalAgreementCompletedCopyTurnOnI18n }}
                </p>
            </div>
            <div class="bottom-margin" *ngIf="!agreementCompleted">
                <p class="body">{{ modalAgreementCompletedCopyTurnOffI18n }}</p>
            </div>
            <data-card class="bottom-margin">
                <div class="data-item">
                    <div class="data-header p label">Buyer:</div>
                    <div class="data-value p body">{{ buyerName }}</div>
                </div>
                <div class="data-item">
                    <div class="data-header p label">Supplier:</div>
                    <div class="data-value p body">{{ supplierPreferredName }}</div>
                </div>
            </data-card>
        </div>
    `
})
export class AgreementCompleteCheckModalComponent {
    public readonly modalAgreementCompletedCopyTurnOnI18n = this._i18n({
        value:
            'By enabling this, you acknowledge that all of the provided information for the following supplier has been reviewed and verified. This allows Eligibility to be enabled for the following supplier(s):',
        description: 'Warning when enabling agreement completed'
    });

    public readonly modalAgreementCompletedCopyTurnOffI18n = this._i18n({
        value:
            'Unchecking the Supplier Agreement Complete will disable Eligibility for the following supplier(s):',
        description: 'Warning when disabling agreement completed'
    });

    public agreementCompleted: boolean;
    public supplierPreferredName: string;
    public buyerName: string;

    constructor(private _modalService: ModalService, private _i18n: I18n) {
        const modalData = this._modalService.modal.data;

        this.agreementCompleted = modalData.agreementCompleted;
        this.supplierPreferredName = modalData.supplierRelationship.supplierPreferredName;
        this.buyerName = modalData.supplierRelationship.allSellerRelationships.find(
            (relationship) => relationship.buyerKey === modalData.supplierRelationship.buyerKey
        ).buyerPreferredName;
    }
}
